import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { FiX } from "react-icons/fi";
import Logo from "../../../assets/logoweb.jpg";
import ForgotPassword from "../Forgot-Password/ForgotPassword";
import { toast } from "react-toastify"; 
import api from "../../../utils/api";
import { useDispatch, useSelector } from "react-redux";
import { LoadUserFail, LoadUserRequest, LoadUserSuccess } from "../../../redux/userSlice";
import { Link, useNavigate } from "react-router-dom";
import { showCustomAlert } from "./Toast";

const CustomeSignInPopup = () => {
  const [isSignInOpen, setIsSignInOpen] = useState(true);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.cart);
  useEffect(() => {
    const savedEmail = Cookies.get("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const closeAllPopups = () => {
    setIsSignInOpen(false);
    setIsForgotPasswordOpen(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    dispatch(LoadUserRequest());

    try {
      const response = await fetch("https://cashback-479780104538.europe-west2.run.app/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      if (response.ok) {
        Cookies.set("accessToken", data.tokens.access.token, { expires: new Date(data.tokens.access.expires) });
        localStorage.setItem("userId", data.user._id);
        Cookies.set("refreshToken", data.tokens.refresh.token, { expires: new Date(data.tokens.refresh.expires) });

        if (rememberMe) {
          Cookies.set("rememberedEmail", email, { expires: 30 });
        } else {
          Cookies.remove("rememberedEmail");
        }

        dispatch(LoadUserSuccess(data.user));
        showCustomAlert({
          title: "Welcome Back!",
          html: "<p style='color: #555;'>You have successfully logged in.</p>",
          icon: "success",
          confirmButtonText: "Continue",
          confirmButtonColor: "#af313d",
          background: "#ffffff",
        });
      
         
        Cookies.get("selectedSlug") ? navigate(`/${Cookies.get("selectedSlug")}`) : navigate("/");
         
        setTimeout(() => {
          window.location.reload()
        }, 1000);
        setIsSignInOpen(false);
 
     } else {
  // ❌ failure flow
  const message = data?.message || "Login failed. Please try again.";
  dispatch(LoadUserFail(message));
  setErrorMessage(message);

  // ✅ Show custom alert instead of plain text
  showCustomAlert({
    title: "Login Failed",
    html: `<p style='color: #555;'>${message}</p>`,
    icon: "error",
    confirmButtonText: "Try Again",
    confirmButtonColor: "#af313d",
    background: "#ffffff",
  });
}

    } catch (error) {
  const message = "An unexpected error occurred. Please try again.";
  dispatch(LoadUserFail(message));
  setErrorMessage(message);

  showCustomAlert({
    title: "Error",
    html: `<p style='color: #555;'>${message}</p>`,
    icon: "error",
    confirmButtonText: "Close",
    confirmButtonColor: "#af313d",
    background: "#ffffff",
  });
}
  };

  return (
    <div>
      {isSignInOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[90%] md:w-[80%] mx-auto lg:w-[50%] rounded-lg shadow-lg relative">
            <button onClick={closeAllPopups} className="absolute top-3 right-6 bg-black rounded-full w-10 h-10 flex items-center justify-center text-xl text-white font-bold hover:text-gray-700">
              <FiX />
            </button>
            <div className="p-8 max-h-[80vh] overflow-y-scroll md:px-16 custom-scrollbar">
              {/* <div className="flex items-center justify-center gap-2">
                    <img src={Logo} alt="" className=" lg:h-[90px]" />
              
              </div> */}
              <h2 className="text-center body lg:text-[28px] font-[700] mb-4 ">Login to your account</h2>
              <form onSubmit={handleLogin}>
                <div className="mb-4">
                  <label htmlFor="email" className="block text-[14px] font-medium text-black font-baloo mb-2">Email Address</label>
                  <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" className="w-full p-3 border border-gray-300 rounded-md" required />
                </div>
                <div className="mb-4">
                  <label htmlFor="password" className="block text-[14px] font-medium text-black font-baloo mb-2">Password</label>
                  <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter your password" className="w-full p-3 border border-gray-300 rounded-md" required />
                </div>
                <div className="flex justify-between items-center">
                  <label className="flex items-center">
                    <input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} className="mr-2 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring focus:ring-blue-200" />
                    Remember me
                  </label>
                  <div className="text-[#156CD7] underline cursor-pointer" onClick={() => { closeAllPopups(); setTimeout(() => setIsForgotPasswordOpen(true), 100); }}>
                    Forgot Password
                  </div>
                </div>
                {errorMessage && <p className="text-red-500 text-sm mb-4">{errorMessage}</p>}
                <button type="submit" className="w-full my-6 rounded-full bg-[#AF313D] text-white p-3 mb-8 text-[14.39px] font-baloo font-semibold">Login</button>
                <div className="flex gap-2 items-center justify-center">
                  <h1 className="text-[#282A37] text-[14px]">Still need help?</h1>
                  <Link to="/contact"><h2 className="text-[#156CD7] text-[14px]">Contact us</h2></Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {isForgotPasswordOpen && <ForgotPassword closeAllPopups={closeAllPopups} />}
    </div>
  );
};

export default CustomeSignInPopup;
